module.exports = __webpack_public_path__ + "static/warehouse-exp-img-2-e6298a369bf5ef3c4acabada0ab8876c.png";